import { useState } from "react";
import { Edit, ShowButton, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

const EditElectiveCourse = () => {
  const [documentId, setDocumentId] = useState(null);

  // The FileInput's own field keeps the raw picked-file preview (see DocumentFileInput) so it
  // stays visible after upload; the actual uploaded id is tracked separately and swapped in here.
  const transform = data => ({ ...data, documentId: documentId ?? data.documentId });

  return (
    <Edit
      title="Редакция на свободноизбираем курс"
      mutationMode="pessimistic"
      transform={transform}
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canPreviewElectiveCourses}>
              <ShowButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm onDocumentUpload={setDocumentId} />
      </SimpleForm>
    </Edit>
  );
};

export default EditElectiveCourse;
